import { get, set } from 'js-cookie';

import { Cookies } from '@/domains/core/httpClient/cookies';
import { getCookieDomain } from '@/domains/core/httpClient/getCookieDomain';

import { IS_LOCAL } from '../../platform/constants';
import { getAppSetting } from '../../settings/appSettings';

/**
 * Retrieves the visitor ID from the cookies if it exists.
 * If not, generates a new UUID, stores it in a cookie, and returns it.
 */
export async function getOrCreateVisitorId(): Promise<string> {
  const visitorIdFromCookie = get(Cookies.MM_VISITOR_ID);
  if (visitorIdFromCookie) {
    return visitorIdFromCookie;
  }

  const visitorId = (await import('uuid')).v4();
  const now = new Date();
  const env = getAppSetting('ENVIRONMENT');

  set(Cookies.MM_VISITOR_ID, visitorId, {
    domain: getCookieDomain(env),
    expires: new Date(now.setFullYear(now.getFullYear() + 1)),
    path: '/',
    secure: !IS_LOCAL,
  });

  return visitorId;
}
